/**
 * all states from store
 */
export default {
  categories: [],
  points: null,
  points_pagination: null,
  pages_already_loaded: [],
  commission: [],
  split_exceptions: [],
  cluster: null,
  partner: [],
  total_points: null,
  category_filter_id: null,
  points_in_request: false,
  faq_questions: [],
  split_clusters_rules: {},
};
